function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6383"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41195",
    d: "M-1034.38 91.953h-4.552a1.565 1.565 0 0 1-1.736-1.733c0-.558 0-.558-.571-.558h-12.47a1.6 1.6 0 0 1-1.769-1.776c0-6.412.011-12.823-.012-19.235a1.708 1.708 0 0 1 1.826-1.811c1.194.036 2.39 0 3.585.015.254 0 .321-.074.3-.311a.715.715 0 0 1 .248-.727.864.864 0 0 1 .6-.094.348.348 0 0 0 .432-.3 2.834 2.834 0 0 1 2.715-2 2.843 2.843 0 0 1 2.718 2.04c.065.223.162.272.365.255a1.747 1.747 0 0 1 .466.014c.278.053.428.286.435.633.01.48.01.48.5.48h3.46a1.625 1.625 0 0 1 1.754 1.746c0 1.6.006 3.2 0 4.8 0 .237.051.311.3.309 2.016-.011 4.032-.007 6.048-.006a1.523 1.523 0 0 1 1.635 1.634v14.964a1.541 1.541 0 0 1-1.658 1.654c-1.539.011-3.081.007-4.619.007z",
    transform: "translate(1058.338 -61.721)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41196",
    d: "M-1041.7 128.578v-9.6c0-.522.121-.647.634-.647h3.647c.216 0 .282.056.281.277 0 .719.155.863.887.863h6.3c.617 0 .8-.175.784-.8-.009-.278.071-.347.345-.343 1.215.015 2.431.005 3.647.007.44 0 .574.135.574.577 0 1.61-.005 3.221.007 4.831 0 .244-.077.294-.3.287-.477-.016-.956-.005-1.434 0a1.541 1.541 0 0 0-1.691 1.676c-.005 1.735 0 3.47 0 5.206 0 2.535 0 5.07.006 7.606 0 .264-.052.352-.338.352q-6.328-.015-12.655-.007c-.548 0-.687-.138-.687-.674q-.007-4.811-.007-9.611z",
    transform: "translate(1045.694 -112.042)",
    style: {
      fill: "#00a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41197",
    d: "M-863.742 208.238v-7.388c0-.487.1-.584.579-.584h9.1c.464 0 .565.1.565.568v14.838c0 .479-.079.556-.564.556h-9.134c-.464 0-.548-.083-.549-.54l.003-7.45z",
    transform: "translate(882.569 -187.157)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41198",
    d: "M-970.614 104.436c.862 0 1.725.007 2.588 0 .22 0 .3.063.275.281-.034.285.126.654-.068.836-.176.165-.536.047-.814.048-1.507 0-3.014 0-4.521.007-.242 0-.322-.06-.32-.313.006-.853 0-.853.833-.853z",
    transform: "translate(983.157 -99.308)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41199",
    d: "M-954.663 78.5h-2.985c-.143 0-.182-.025-.119-.176a1.7 1.7 0 0 1 1.619-.955 1.627 1.627 0 0 1 1.485 1.131z",
    transform: "translate(968.786 -74.499)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41200",
    d: "M-1007.938 160.371h-5.514c-.469 0-.726-.213-.721-.586a.508.508 0 0 1 .4-.526 1.67 1.67 0 0 1 .431-.044h10.841a2.093 2.093 0 0 1 .341.021.58.58 0 0 1 .518.566.6.6 0 0 1-.533.56 2.131 2.131 0 0 1-.311.01z",
    transform: "translate(1020.464 -149.524)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41201",
    d: "M-1009.6 200.264h3.767a1.037 1.037 0 0 1 .4.05.538.538 0 0 1 .369.555.525.525 0 0 1-.423.513 1.427 1.427 0 0 1-.338.04h-7.6c-.471 0-.719-.183-.744-.53-.028-.383.224-.623.676-.626.83-.005 1.66 0 2.49 0z",
    transform: "translate(1020.465 -187.154)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41202",
    d: "M-1009.643 242.5h-3.834c-.47 0-.7-.187-.7-.561s.253-.572.7-.572h7.7c.548 0 .868.428.636.841a.615.615 0 0 1-.607.295c-1.297-.011-2.596-.003-3.895-.003z",
    transform: "translate(1020.466 -224.828)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41203",
    d: "M-850.151 286.458v-3.271c0-.52.2-.721.71-.721h6.572c.494 0 .7.205.7.7v6.572c0 .5-.2.705-.694.706h-6.6c-.474 0-.681-.21-.682-.687q-.009-1.648-.006-3.299z",
    transform: "translate(870.111 -262.507)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41204",
    d: "M-846.141 214.19h3.271c.5 0 .693.2.694.7v3.147c0 .49-.211.71-.7.71h-6.574c-.494 0-.708-.214-.709-.7v-3.178c0-.479.2-.678.682-.679q1.669-.003 3.336 0z",
    transform: "translate(870.117 -199.921)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41205",
    d: "M-807.57 350.713c.478 0 .955.009 1.432 0 .206-.005.276.063.262.268a6.84 6.84 0 0 0 0 .716c0 .135-.051.181-.183.181h-3.052c-.153 0-.186-.058-.194-.2-.054-.962-.058-.961.9-.961z",
    transform: "translate(832.688 -325.063)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41206",
    d: "M-835.4 296.614c0 .587 0 .587-.59.587-.567 0-.567 0-.567-.577s0-.583.587-.583c.57 0 .57 0 .57.573z",
    transform: "translate(857.654 -274.951)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41207",
    d: "M-781.269 296.041c.586 0 .586 0 .586.584s0 .576-.567.576c-.59 0-.59 0-.59-.587s0-.573.571-.573z",
    transform: "translate(807.492 -274.951)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41208",
    d: "M-835.99 351.914c-.572 0-.572 0-.572-.567 0-.593 0-.593.581-.593s.576 0 .576.57c.005.59.005.59-.585.59z",
    transform: "translate(857.654 -325.105)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41209",
    d: "M-809.056 296.6c0-.56 0-.56.57-.56s.563 0 .563.567c0 .592 0 .592-.6.592-.533.001-.533.001-.533-.599z",
    transform: "translate(832.44 -274.954)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41210",
    d: "M-836.558 324.1c0-.54 0-.54.533-.54.623 0 .623 0 .623.639 0 .494 0 .494-.488.494h-.062c-.606.007-.606.007-.606-.593z",
    transform: "translate(857.65 -300.18)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41211",
    d: "M-781.243 323.564c.564 0 .564 0 .564.572s0 .56-.545.56c-.612 0-.612 0-.612-.619 0-.513 0-.513.593-.513z",
    transform: "translate(807.489 -300.18)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41212",
    d: "M-808.509 324.7c-.544 0-.544 0-.544-.557 0-.575 0-.575.589-.575.544 0 .544 0 .544.557 0 .575 0 .575-.589.575z",
    transform: "translate(832.437 -300.183)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41213",
    d: "M-833.744 227.735c.863 0 1.725.007 2.588-.005.221 0 .281.064.275.28a40.652 40.652 0 0 0 0 1.746c0 .185-.047.254-.243.253q-2.619-.01-5.238 0c-.162 0-.246-.029-.243-.22.01-.613.011-1.226 0-1.839 0-.2.085-.216.243-.215.872.003 1.745 0 2.618 0z",
    transform: "translate(857.695 -212.332)",
    style: {
      fill: "#faf871"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAmount);
export default __webpack_public_path__ + "static/media/TotalAmount.feffafae303dcbbb6a1f56dde393ae6b.svg";
export { ForwardRef as ReactComponent };